import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SidebarType } from '../../enums/sidebar-type';
import { environment } from 'src/environments/environment';
import { ScreenBrakepoints } from 'src/app/data/model/screen-brakepoints';
import { SpinnerService } from 'src/app/shared/spinner/spinner.service';
import { SharedService } from 'src/app/core/service/shared.service';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {
  @Input() isSidebarVisible: boolean;
  @Input() isSettingsSidebar: boolean = false;
  @Input() isUploadSidebar: boolean = false;
  @Input() recordId: string = '';
  @Input() isBankTransMode: boolean = false;
  @Input() initialFiles: File[] = null;
  isMobileDevice: boolean = false;
  screenBrakepoint: ScreenBrakepoints = ScreenBrakepoints.MinWidth769px;

  @Output() isClosed = new EventEmitter<SidebarType>();
  @Output() uploadedFile = new EventEmitter<object>();
  protected unsubscribe$ = new Subject<void>();
  
  constructor(
    public spinnerService: SpinnerService,
    public readonly sharedService: SharedService,
    private readonly _breakpointObserver: BreakpointObserver,
  ) { }

  readonly untilThis = <T>(source: Observable<T>) =>
      source.pipe(takeUntil(this.unsubscribe$));

  ngOnInit(): void {
    this.sharedService.screenBrakepoint$
      .pipe(this.untilThis)
      .subscribe(
        (breakpoint) => {
          this.screenBrakepoint = breakpoint;
        });

    this.checkIfMobileDevice();        
  }
  cancel(type: SidebarType) {
    this.isSettingsSidebar = false;
    this.isUploadSidebar = false;
    this.isClosed.emit(type);
  }

  checkIfMobileDevice() {
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || environment.isOutlookEnv || environment.isChromeEnv) {
      // true for mobile device
      if (this.screenBrakepoint <= ScreenBrakepoints.MaxWidth428px)
        return true;
      else
        return false;
    } else {
      return false;
    }
  }
  uploadFile(file: any) {
    this.uploadedFile.emit(file);
  }
}
